(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/coupons/coupon-1x2.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/coupons/coupon-1x2.js');
"use strict";


const {
  useEffect,
  useRef
} = React;
const {
  ReactButtonBet
} = svs.components;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  signIndexToTitle
} = svs.components.sport.tipsenShared;
const {
  getPixHandler
} = svs.components.sport.pixHandler;

const useMemoizedMinHeight = _ref => {
  let {
    ref,
    hasData
  } = _ref;
  useEffect(() => {
    if (ref.current) {
      if (hasData) {
        ref.current.removeAttribute('style');
      }
      const height = ref.current.getBoundingClientRect().height;
      ref.current.setAttribute('style', "min-height: ".concat(height, "px;"));
    }
  });
};

const Coupon1x2 = _ref2 => {
  let {
    branding,
    drawData,
    isPixMix
  } = _ref2;
  const {
    productId,
    events
  } = drawData || {};
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  return React.createElement("div", {
    className: "padding-left-2 padding-right-2"
  }, React.createElement("div", {
    className: "f-medium u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 fc-opacity-white-80"
  }, React.createElement("div", null, "Match"), React.createElement("div", {
    "data-testid": "table-of-events-goal-type"
  }, "Tippa resultat")), events.map((eventItem, eventIndex) => React.createElement(MatchRow, {
    branding: branding,
    eventIndex: eventIndex,
    eventItem: eventItem,
    isMobile: isMobile,
    isPixMix: isPixMix
    ,
    key: "".concat(eventItem.captionShort, "_").concat(eventIndex),
    productId: productId
  })));
};

const MatchRow = _ref3 => {
  let {
    eventItem,
    eventIndex,
    branding,
    productId,
    isMobile,
    isPixMix
  } = _ref3;
  const ref = useRef();
  const pixHandler = getPixHandler({
    isPixMix
  });
  const pixData = pixHandler.getModel(productId);
  useMemoizedMinHeight({
    ref,
    hasData: Boolean(pixData)
  });
  const {
    captionShort,
    captionLong,
    infoLine,
    outcomesAsList
  } = eventItem;
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 notranslate padding-top padding-bottom u-flex-align-items-center",
    key: "".concat(captionShort, "-").concat(eventIndex),
    ref: ref
  }, React.createElement("div", {
    "data-testid": "event-".concat(eventIndex, "-description")
  }, React.createElement("div", null, "".concat(eventIndex + 1, ". ").concat(isMobile ? captionShort : captionLong)), Boolean(infoLine) && React.createElement("div", {
    className: "padding-left-1 fc-grey-400"
  }, infoLine)), React.createElement("div", {
    className: "u-flex f-100 fc-white quickplay-modal2-outcomes",
    "data-testid": "event-".concat(eventIndex, "-outcomes")
  }, React.createElement(EventOutcomes, {
    branding: branding,
    eventIndex: eventIndex,
    isPixMix: isPixMix,
    outcomesAsList: outcomesAsList,
    productId: productId
  })));
};

const EventOutcomes = _ref4 => {
  let {
    eventIndex,
    outcomesAsList,
    branding,
    productId,
    isPixMix
  } = _ref4;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const pixData = pixHandler.getModel(productId);
  const signs = (pixData === null || pixData === void 0 ? void 0 : pixData[eventIndex]) || [];
  const labels = outcomesAsList || signIndexToTitle[EventTypeId.EVENT_1X2];
  return React.createElement(React.Fragment, null, signs.map((isSelected, signIndex) => React.createElement(ReactButtonBet, {
    branding: branding,
    className: "margin-half",
    disabled: !labels[signIndex]
    ,
    key: "".concat(signIndex, "_").concat(labels[signIndex]),
    label: labels[signIndex],
    selected: isSelected,
    size: "200",
    tabIndex: "-1"
  })));
};
setGlobal('svs.components.sport.quickplayModal2.coupons.Coupon1x2', Coupon1x2);

 })(window);